var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meta)?_c('div',{staticClass:"text-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.lastPage,"total-visible":_vm.totalVisible},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }